// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select } from 'antd';

import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import styles from './styles.module.css';

const EditUser = ({ modalVisible, closeModal, selUser, submitFeedback }) => {
    const handleCancel = () => {
        closeModal();
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [locations, setLocations] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [addSublocation, setAddSublocation] = useState(false);

    // Add a state to store user data
    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        isPhoneVerified: false,
        type: '',
        isUserTester: false,
        isEmailVerified: false,
        access: {
            dashboard: false,
            timeline: false,
        },
        customerLocation: [],
        userGroups:[],
        location:[],
        // showLocationSelector:false,
        // isAutoPayEnabled:false

    });

    useEffect(() => {

        if (selUser) {
            setUserData({
                id: selUser?._id,
                firstName: selUser?.firstName,
                lastName: selUser?.lastName,
                email: selUser?.email,
                phone: selUser?.phone,
                isPhoneVerified: selUser?.isPhoneVerified,
                type: selUser?.type,
                isUserTester: selUser?.isUserTester,
                isEmailVerified: selUser?.isEmailVerified,
                access: {
                    dashboard: selUser?.access?.dashboard,
                    timeline: selUser?.access?.timeline,
                },
                customerLocation: selUser?.customerLocation?.length ? selUser?.customerLocation : [],
                userGroups: selUser?.userGroups,
                location:selUser?.location,
                // showLocationSelector:selUser?.showLocationSelector,
                // isAutoPayEnabled:selUser?.isAutoPayEnabled,
              
            });
        }

    }, [selUser])

    useEffect(() => {
        setIsLoading(true);
        setUserData({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            isPhoneVerified: false,
            type: '',
            isUserTester: false,
            isEmailVerified: false,
            access: {
                dashboard: false,
                timeline: false,
            },
            customerLocation: [],
            userGroups:[],
        location:[],
        // showLocationSelector:false,
        // isAutoPayEnabled:false
        });
        getLocationsData();
        setIsLoading(false);
    }, [])


    useEffect(() => {
        console.log(form);
        if (userData.type !== 'Customer') {
            setUserData((prev) => ({
                ...prev,
                access: {
                    ...prev.access,
                    dashboard: false,
                    timeline: false,
                },

                customerLocation: [],
            }));
        }
        else {
            setUserData((prev) => ({
                ...prev,
                access: {
                    // ...prev.access,
                    // dashboard: selUser?.access?.dashboard,
                    // timeline: selUser?.access?.timeline,
                    dashboard: true,
                    timeline: true,
                },
                customerLocation: selUser?.customerLocation,
            }));
        }
    }, [userData.type])


    useEffect(() => {
        if (userData?.customerLocation?.length > 0) {
            setUserData((prev) => ({
                ...prev,
                access: {
                    ...prev.access,
                    dashboard: true,
                },
            }));
        }
        else {
            setUserData((prev) => ({
                ...prev,
                access: {
                    ...prev.access,
                    dashboard: false,
                },
            }));
        }
    }, [userData?.customerLocation])







    const { Option } = Select;
    const [form] = Form.useForm(); 


    const userSubmit = async () => {

        if (userData.type === 'Customer' && userData?.customerLocation?.length == 0) {
            toast.error('Please select a location');
            return;
        }

        try {
            setIsSubmitting(true);
            const res = await BreathAPIs.updateUser(userData, addSublocation);
            form.resetFields();
            submitFeedback(res?.data?.message);
            setIsSubmitting(false);
            closeModal();
        } catch (error) {
            toast.error('Error adding user.');
            setIsSubmitting(false);
        }

    };

    const getLocationsData = async () => {
        try {
            const res = await BreathAPIs.getDashboardFilterLocations()
            setLocations(res.data.locations);

        } catch (error) {
            console.log('Error while retrieving locations data', error);
        }
    }

    return (
        <Modal
            title="Edit User"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? "100%" : "50%"}
            destroyOnClose={() => setUserData({})}
        >
          
            {/* {console.log('user data: ',userData)} */}
            {isLoading ? <div>Loading...</div> : <Form form={form} onFinish={userSubmit} layout={'vertical'} initialValues={userData}>
                {/* Render form fields for user data */}
                <Form.Item label="First Name" >
                    <Input value={userData.firstName + ''} onChange={(e) => setUserData((prev) => ({ ...prev, firstName: e.target.value }))} />
                </Form.Item>


                <Form.Item label="Last Name" >
                    <Input value={userData.lastName} onChange={(e) => setUserData((prev) => ({ ...prev, lastName: e.target.value }))} />
                </Form.Item>

                {/* <Form.Item label={`Email`} >
                    <Input disabled value={userData.email} onChange={(e) => setUserData((prev) => ({ ...prev, email: e.target.value }))} />
                </Form.Item>
                <Form.Item label="Is Email Verified" valuePropName="checked">
                    <Switch checked={userData.isEmailVerified} onChange={(checked) => setUserData((prev) => ({ ...prev, isEmailVerified: checked }))} />
                </Form.Item> */}
                <Form.Item
  label={
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span>Email (Is Email Verified) : </span>
      <Switch
        disabled={userData.email?false:true}
        style={{ marginLeft: 8 }}
        checked={userData.isEmailVerified}
        onChange={(checked) =>
          setUserData((prev) => ({ ...prev, isEmailVerified: checked }))
        }
      />
    </div>
  }
>
  <Input
    disabled
    value={userData.email}
    onChange={(e) =>
      setUserData((prev) => ({ ...prev, email: e.target.value }))
    }
  />
</Form.Item>

                <Form.Item
                    label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>Phone (Is Phone Verified) : </span>
                        <Switch
                            disabled={userData.phone?false:true}
                            style={{ marginLeft: 8 }}
                            checked={userData.isPhoneVerified}
                            onChange={(checked) =>
                            setUserData((prev) => ({ ...prev, isPhoneVerified: checked }))
                            }
                        />
                        </div>
                    }
                    >
                    <Input
                        value={userData.phone}
                        onChange={(e) =>
                        setUserData((prev) => ({ ...prev, phone: e.target.value }))
                        }
                    />
                    </Form.Item>


                <Form.Item label="User Type" className={styles['edit-user-type']}>
                    <Select value={userData.type} onChange={(value) => setUserData((prev) => ({ ...prev, type: value }))}>
                        <Option value="User">User</Option>
                        <Option value="Customer">Customer</Option>
                    </Select>

                    {userData.type === 'Customer' && <div>
                        <hr />
                        <Form.Item label="Permitted locations" 
                        // name="permittedLocation"
                        >
                            <Select
                                mode="multiple"
                                placeholder="Please select"
                                defaultValue={
                                    selUser?.customerLocation?.map((loc) => loc) 
                                }
                                // value={userData.customerLocation}
                                onChange={(selectedValues) => setUserData((prev) => ({ ...prev, customerLocation: selectedValues }))}
                                style={{ width: '100%' }}
                                options={locations?.map((loc) => ({
                                    value: loc?._id,
                                    label: loc?.locationName,
                                }))}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                            <Form.Item label="Dashboard Access" valuePropName="checked">
                                <Switch
                                    // disabled={true}
                                    checked={userData.access.dashboard}
                                    onChange={(checked) => setUserData((prev) => ({
                                        ...prev,
                                        access: {
                                            ...prev.access,
                                            dashboard: checked
                                        }
                                    }))}
                                />
                            </Form.Item>
                            <Form.Item label="Timeline Access" valuePropName="checked">
                                <Switch
                                    checked={userData.access.timeline}
                                    onChange={(checked) => setUserData((prev) => ({
                                        ...prev,
                                        access: {
                                            ...prev.access,
                                            timeline: checked
                                        }
                                    }))}
                                />
                            </Form.Item>
                            <Form.Item label='Add sublocations' valuePropName="checked">
                                <Switch
                                    checked={addSublocation}
                                    onChange={(checked) => setAddSublocation(checked)}
                                />
                            </Form.Item>
                        </div>
                    </div>}
                </Form.Item>

                <Form.Item label="User Tester" valuePropName="checked">
                    <Switch checked={userData.isUserTester} onChange={(checked) => setUserData((prev) => ({ ...prev, isUserTester: checked }))} />
                </Form.Item>

                {/* <Form.Item label="Auto Pay Enabled" valuePropName="checked">
                    <Switch checked={userData.isAutoPayEnabled} onChange={(checked) => setUserData((prev) => ({ ...prev, isAutoPayEnabled: checked }))} />
                </Form.Item>
                </Form.Item>

                {/* <Form.Item label="Auto Pay Enabled" valuePropName="checked">
                    <Switch checked={userData.isAutoPayEnabled} onChange={(checked) => setUserData((prev) => ({ ...prev, isAutoPayEnabled: checked }))} />
                </Form.Item>

                <Form.Item label="Location Selector Enabled" valuePropName="checked">
                    <Switch checked={userData.showLocationSelector} onChange={(checked) => setUserData((prev) => ({ ...prev, showLocationSelector: checked }))} />
                </Form.Item> */}


                <div className="col-md-12">
                    <Form.Item style={{ textAlign: 'right' }}>
                        <ButtonCustom isLoading={isSubmitting} text={isSubmitting ? 'Updating...' : 'Update User'} type='submit' />
                    </Form.Item>
                </div>
            </Form>}
        </Modal >
    );
};

export default EditUser;
